<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-highlight`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 6.474a2 2 0 00-2.42-1.956l-10 2.143A2 2 0 0017 8.617V16h-3c-1.105 0-2 .758-2 1.692V25H9c-1.105 0-2 .733-2 1.636V44a1 1 0 001 1h2a1 1 0 001-1V29h5v-9h16v9h5v15a1 1 0 001 1h2a1 1 0 001-1V26.636c0-.903-.895-1.636-2-1.636h-3v-7.308c0-.934-.895-1.692-2-1.692h-3V6.474zm-10 3.76l6-1.286V16h-6v-5.766z"/></svg>
</template>
<script>

export default {
  name: 'IconHighlight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
